export const CASCADING_SELECT_GQL_TYPE = 'JiraCascadingSelectField';
